import vue from 'vue'
export default {
  namespaced: true,
  state: {
    header: {
      id_aju: '',
      encoded_id: '',
      no_aju: '',
      kd_status: '',
      jns_aju: '',
      tgl_aju: '',
      no_daftar: '',
      tgl_daftar: '',
      no_sppb: '',
      tgl_sppb: '',
      nama: '',
      jns_identitas: '',
      no_identitas: '',
      alamat: '',
      fl_kuasa: false,
      nama_kuasa: '',
      jns_identitas_kuasa: '',
      no_identitas_kuasa: '',
      alamat_kuasa: '',
      moda_angkutan: '',
      nama_sarkut: '',
      no_voyage: '',
      pel_muat: '',
      pel_tujuan: '',
      id_gudang: '',
      bruto: '',
      netto: '',
      tgl_pengeluaran: '',
      no_kk: '',
      tgl_kk: '',
      no_dukcapil: '',
      tgl_dukcapil: '',
      no_surat_pindah: '',
      tgl_pindah: '',
      no_surat_kuasa: '',
      tgl_surat_kuasa: '',
      no_surat_pernyataan: '',
      tgl_surat_pernyataan: '',
      no_surat_rekombp: '',
      tgl_surat_rekombp: '',
      no_pl: '',
      tgl_pl: '',
      no_bpkb: '',
      tgl_bpkb: '',
      no_stnk: '',
      tgl_stnk: '',
      no_ntpn: '',
      tgl_ntpn: '',
      kode_billing: '',
      ref_pel_muat: [],
      ref_pel_tujuan: [],
      fl_hold: false,
      no_bukti_gesek: '',
      tgl_bukti_gesek: ''
    },
    barang: [],
    current_barang: [],
    files: {
      file_identitas_penerima: null,
      file_identitas_pengirim: null,
      file_kk: null,
      file_dukcapil: null,
      file_pindah: null,
      file_kuasa: null,
      file_pernyataan: null,
      file_rekombp: null,
      file_pl: null,
      file_stnk: null,
      file_bpkb: null,
      file_ntpn: null,
      file_billing: null,
      file_lain_lain: null,
      file_bukti_gesek: null
    },
    kontainer: [],
    kemasan: [],
    current_kemasan: [],
    respon: {
      id: '',
      status: ''
    },
    catatan: [],
    isLoadingModal: false,
    current_id_billing: '',
    isLoading: false
  },
  mutations: {
    UPDATE_HEADER (state, payload) {
      state.header[payload.where] = payload.value
    },
    UPDATE_FILE (state, payload) {
      state.files[payload.where] = payload.value
    },
    ADD_BARANG (state, payload) {
      state.barang.push(payload)
    },
    REMOVE_BARANG (state, payload) {
      state.barang.splice(payload, 1)
    },
    SET_BARANG (state, payload) {
      state.barang = payload
    },
    SET_DETIL_BARANG (state, payload) {
      state.current_barang = payload
    },
    UPDATE_BARANG (state, payload) {
      state.current_barang[payload.where] = payload.value
    },
    SET_RESPON (state, payload) {
      state.respon.id = payload.id
      state.respon.status = payload.status
    },
    SET_BILLING_ID (state, payload) {
      state.current_id_billing = payload
      state.files.file_ntpn = null
    },
    SET_KONTAINER (state, payload) {
      state.kontainer = payload
    },
    SET_KEMASAN (state, payload) {
      state.kemasan = payload
    },
    SET_DETIL_KEMASAN (state, payload) {
      state.current_kemasan = payload
    },
    UPDATE_KEMASAN (state, payload) {
      state.current_kemasan[payload.where] = payload.value
    },
    ADD_KONTAINER (state, payload) {
      state.kontainer.push(payload)
    },
    REMOVE_KONTAINER (state, payload) {
      state.kontainer.splice(payload, 1)
    },
    SET_LOADING (state, payload) {
      state.isLoading = payload
    },
    SET_LOADING_MODAL (state, payload) {
      state.isLoadingModal = payload
    },
    SET_HEADER (state, payload) {
      state.header.id_aju = payload.ID_AJU
      state.header.encoded_id = payload.encoded_id
      state.header.jns_aju = payload.JNS_AJU
      state.header.kd_status = payload.KD_STATUS
      state.header.no_daftar = payload.NO_DAFTAR
      state.header.tgl_daftar = payload.TGL_DAFTAR
      state.header.no_sppb = payload.NO_SPPB
      state.header.tgl_sppb = payload.TGL_SPPB
      state.header.no_aju = payload.NO_AJU
      state.header.tgl_aju = payload.TGL_AJU
      state.header.jns_identitas = payload.JNS_IDENTITAS_PENERIMA
      state.header.no_identitas = payload.NO_IDENTITAS_PENERIMA
      state.header.nama = payload.NAMA_PENERIMA
      state.header.alamat = payload.ALAMAT_PENERIMA
      state.header.fl_kuasa = payload.FL_KUASA === 1
      state.header.jns_identitas_kuasa = payload.JNS_IDENTITAS_PENGIRIM
      state.header.no_identitas_kuasa = payload.NO_IDENTITAS_PENGIRIM
      state.header.nama_kuasa = payload.NAMA_PENGIRIM
      state.header.alamat_kuasa = payload.ALAMAT_PENGIRIM
      state.header.moda_angkutan = payload.MODA_ANGKUTAN
      state.header.pel_muat = payload.KD_PEL_MUAT
      state.header.pel_tujuan = payload.KD_PEL_TUJUAN
      state.header.id_gudang = payload.ID_GUDANG
      state.header.bruto = payload.BRUTO
      state.header.netto = payload.NETTO
      state.header.tgl_pengeluaran = payload.TGL_PENGELUARAN
      state.header.no_surat_kuasa = payload.NO_SURAT_KUASA
      state.header.tgl_surat_kuasa = payload.TGL_SURAT_KUASA
      state.header.no_kk = payload.NO_KK
      state.header.tgl_kk = payload.TGL_KK
      state.header.no_dukcapil = payload.NO_DUKCAPIL
      state.header.tgl_dukcapil = payload.TGL_DUKCAPIL
      state.header.no_surat_pindah = payload.NO_SURAT_PINDAH
      state.header.tgl_pindah = payload.TGL_PINDAH
      state.header.no_surat_pernyataan = payload.NO_SURAT_PERNYATAAN
      state.header.tgl_surat_pernyataan = payload.TGL_SURAT_PERNYATAAN
      state.header.no_surat_rekombp = payload.NO_SURAT_REKOMBP
      state.header.tgl_surat_rekombp = payload.TGL_SURAT_REKOMBP
      state.header.no_pl = payload.NO_PL
      state.header.tgl_pl = payload.TGL_PL
      state.header.nama_sarkut = payload.NAMA_SARKUT
      state.header.no_voyage = payload.NO_VOYAGE
      state.header.no_bpkb = payload.NO_BPKB
      state.header.tgl_bpkb = payload.TGL_BPKB
      state.header.no_stnk = payload.NO_STNK
      state.header.tgl_stnk = payload.TGL_STNK
      state.header.no_ntpn = payload.NO_NTPN
      state.header.tgl_ntpn = payload.TGL_NTPN
      state.header.kode_billing = payload.KODE_BILLING
      state.header.no_bukti_gesek = payload.NO_BUKTI_GESEK
      state.header.tgl_bukti_gesek = payload.TGL_BUKTI_GESEK
      state.header.fl_hold = payload.FL_HOLD
      state.header.no_surat_jalan = payload.NO_SURAT_JALAN
      state.header.tgl_surat_jalan = payload.TGL_SURAT_JALAN
      // file
      state.files.file_identitas_penerima = payload.FILE_IDENTITAS_PENERIMA
      state.files.file_identitas_pengirim = payload.FILE_IDENTITAS_PENGIRIM
      state.files.file_dukcapil = payload.FILE_DUKCAPIL
      state.files.file_pindah = payload.FILE_PINDAH
      state.files.file_kk = payload.FILE_KK
      state.files.file_kuasa = payload.FILE_KUASA
      state.files.file_rekombp = payload.FILE_REKOMBP
      state.files.file_pernyataan = payload.FILE_PERNYATAAN
      state.files.file_pl = payload.FILE_PL
      state.files.file_stnk = payload.FILE_STNK
      state.files.file_bpkb = payload.FILE_BPKB
      state.files.file_ntpn = payload.FILE_NTPN
      state.files.file_billing = payload.FILE_BILLING
      state.files.file_bukti_gesek = payload.FILE_BUKTI_GESEK
      state.files.file_lain_lain = payload.FILE_LAIN_LAIN
      state.files.file_surat_jalan = payload.FILE_SURAT_JALAN
      // ref
      state.header.ref_pel_muat = payload.pelabuhan_muat
      state.header.ref_pel_tujuan = payload.pelabuhan_tujuan
    },
    SET_CATATAN (state, payload) {
      state.catatan = payload
    }
  },
  getters: {
    kontainer (state) {
      return state.kontainer
    }
  },
  actions: {
    getData ({commit}, payload) {
      // commit('SET_LOADING', true)
      return vue.http.get(`ppftz/${payload}`).then((response) => {
        commit('SET_HEADER', response.data)
        // commit('SET_LOADING', false)
      })
    },
    saveData ({commit, state, dispatch}, payload) {
      commit('SET_LOADING', true)
      return vue.http
        .put('ppftz', state.header)
        .then(() => {
          commit('SET_LOADING', false)
        })
        .then(() => {
          dispatch('getData', payload)
        })
    },
    removeData ({commit}, payload) {
      commit('SET_LOADING', true)
      return vue.http.delete('ppftz', {body: payload}).then(() => {
        commit('SET_LOADING', false)
      })
    },
    // BARANG //
    setBarang ({dispatch}, payload) {
      return vue.http.post('ppftz/barang', payload).then(() => {
        dispatch('getBarang', payload.id_aju)
      })
    },
    getBarang ({commit}, payload) {
      // commit('SET_LOADING', true)
      vue.http.get(`ppftz/barang/${payload}`).then((response) => {
        commit('SET_BARANG', response.data)
        // commit('SET_LOADING', false)
      })
    },
    getDetilBarang ({commit}, payload) {
      // commit('SET_LOADING', true)
      vue.http.get(`ppftz/barang/detil/${payload}`).then((response) => {
        commit('SET_DETIL_BARANG', response.data)
        // commit('SET_LOADING', false)
      })
    },
    removeBarang ({commit, dispatch}, payload) {
      commit('SET_LOADING', true)
      vue.http.delete('ppftz/barang', {body: payload}).then(() => {
        dispatch('getBarang', payload.ID_AJU)
        commit('SET_LOADING', false)
      })
    },
    updateBarang ({dispatch, state}, payload) {
      return vue.http.put('ppftz/barang', payload).then(() => {
        dispatch('getBarang', state.header.id_aju)
      })
    },
    // KONTAINER //
    setKontainer ({dispatch}, payload) {
      return vue.http.post('ppftz/kontainer', payload).then(() => {
        dispatch('getKontainer', payload.id_aju)
      })
    },
    getKontainer ({commit}, payload) {
      vue.http.get(`ppftz/kontainer/${payload}`).then((response) => {
        commit('SET_KONTAINER', response.data)
        // commit('SET_LOADING', false)
      })
    },
    removeKontainer ({commit, dispatch}, payload) {
      commit('SET_LOADING', true)
      vue.http.delete('ppftz/kontainer', {body: payload}).then(() => {
        dispatch('getKontainer', payload.ID_AJU)
        commit('SET_LOADING', false)
      })
    },
    // KEMASAN
    setKemasan ({dispatch}, payload) {
      return vue.http.post('ppftz/kemasan', payload).then(() => {
        dispatch('getKemasan', payload.id_aju)
      })
    },
    getKemasan ({commit}, payload) {
      vue.http.get(`ppftz/kemasan/${payload}`).then((response) => {
        commit('SET_KEMASAN', response.data)
      })
    },
    getDetilKemasan ({commit}, payload) {
      vue.http.get(`ppftz/kemasan/detil/${payload}`).then((response) => {
        commit('SET_DETIL_KEMASAN', response.data)
      })
    },
    updateKemasan ({dispatch, state}, payload) {
      return vue.http.put('ppftz/kemasan', payload).then(() => {
        dispatch('getKemasan', state.header.id_aju)
      })
    },
    // UPLOAD FILE
    setFile ({commit}, payload) {
      commit('SET_LOADING', true)
      return vue.http.post('ppftz/upload', payload).then((res) => {
        var file = {
          where: payload.key_file,
          value: res.data.filename
        }
        commit('UPDATE_FILE', file)
        commit('SET_LOADING', false)
      })
    },
    getCatatan ({commit}, payload) {
      commit('SET_LOADING_MODAL', true)
      var data = {
        ID_AJU: payload
      }
      return vue.http.post('catatan', data).then((response) => {
        commit('SET_LOADING_MODAL', false)
        commit('SET_CATATAN', response.data)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/barpin.js